module.exports = __webpack_public_path__ + "static/media/PC_Wokshop_INTELIGENCIA_EM_CYBERSECURITY_COM_ETHICAL_HACKING.1eb2a32d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/intelCyberEthical/PC_Wokshop_INTELIGENCIA_EM_CYBERSECURITY_COM_ETHICAL_HACKING.png
// module id = 85
// module chunks = 0